module.exports = __webpack_public_path__ + "media/Diagnose John_neu_Stufe01.20dad157.mp4";